module.exports = __webpack_public_path__ + "img/contactus.10655418.jpg";